// A ticking clock for the header and the login page.
//
// It updates once a second but only re-renders when the displayed minute
// actually changes, so a clock showing "14:32" does not repaint the header
// sixty times a minute.

import { useEffect, useState } from 'react';

export function useClock(): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setNow((previous) => {
        const next = new Date();
        return next.getMinutes() === previous.getMinutes() && next.getHours() === previous.getHours()
          ? previous
          : next;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return now;
}
